import React from 'react';
import axios from './axiosConfig';

// The running C2C version, fetched once from /api/version and cached at module
// scope so every consumer (sidebar logos, about, etc.) shares one request. The
// backend serves the first token of its VERSION file (e.g. "8.0.14").
let _cache = null;
let _promise = null;

const fetchVersion = () => {
	if (_cache !== null) return Promise.resolve(_cache);
	if (!_promise) {
		_promise = axios
			.get('/api/version')
			.then(({ data }) => {
				_cache = (data && data.version) || '';
				return _cache;
			})
			.catch(() => {
				_cache = '';
				return _cache;
			});
	}
	return _promise;
};

export default function useAppVersion() {
	const [ version, setVersion ] = React.useState(_cache || '');
	React.useEffect(() => {
		let alive = true;
		fetchVersion().then((v) => {
			if (alive) setVersion(v);
		});
		return () => {
			alive = false;
		};
	}, []);
	return version;
}
